import { computed } from 'vue-demi';
import { SupportType } from '../assets/config/index';

export default (props)=> {
    /* 自定义渲染标签 */
    const tagMap = computed(() => {
        const tagString = props.tagString;
        const map = {};
        if (!tagString) {
            return map;
        }
        const tagArr = tagString.split('/');
        tagArr.forEach((item) => {
            const [key, value] = item.split('-');
            if (key) {
                // 转为大写
                map[key.toUpperCase()] = value;
            }
        });
        return map;
    });

    /**
     * @futu/stock-quotes 提供的接口中的获取历史涨幅类型有限
     * 部分类型无法获取，需要从 kline 的数据中计算
    */
    const isSupported = computed(()=>{
        if (SupportType.includes(props.increaseType)){
            return true;
        } else {
            return false;
        }
    });

    return {
        tagMap,
        isSupported
    };
};
